import {forwardRef} from 'react'

interface CameraViewProps {
  detectionStatus: 'searching' | 'detected' | 'capturing'
}

export const CameraView = forwardRef<HTMLVideoElement, CameraViewProps>(
  ({detectionStatus}, ref) => {
    return (
      <div className='gori-signature-camera-container' role='region' aria-label='Camera view'>
        <div className='gori-signature-camera-video-wrapper'>
          <video
            ref={ref}
            autoPlay
            playsInline
            className='gori-signature-camera-video'
            aria-label='Live camera feed'
          />
          <div className='gori-signature-camera-overlay' aria-hidden='true'>
            <div
              className={`gori-signature-camera-frame ${
                detectionStatus === 'detected' ? 'detected' : ''
              } ${detectionStatus === 'capturing' ? 'capturing' : ''}`}
            >
              <div className='corner top-left'>
                <svg viewBox='0 0 40 40'>
                  <path d='M 4 36 L 4 12 A 12 12 0 0 1 12 4 L 36 4' />
                </svg>
              </div>
              <div className='corner top-right'>
                <svg viewBox='0 0 40 40'>
                  <path d='M 4 36 L 4 12 A 12 12 0 0 1 12 4 L 36 4' />
                </svg>
              </div>
              <div className='corner bottom-left'>
                <svg viewBox='0 0 40 40'>
                  <path d='M 4 36 L 4 12 A 12 12 0 0 1 12 4 L 36 4' />
                </svg>
              </div>
              <div className='corner bottom-right'>
                <svg viewBox='0 0 40 40'>
                  <path d='M 4 36 L 4 12 A 12 12 0 0 1 12 4 L 36 4' />
                </svg>
              </div>
            </div>
            {detectionStatus === 'capturing' && (
              <div className='gori-signature-capture-indicator' role='status' aria-live='polite'>
                <img
                  src='/media/gori/gori-signature/reload.svg'
                  alt='Processing capture'
                  style={{width: '40px', animation: 'spin 1s linear infinite'}}
                  aria-hidden='true'
                />
                <span className='visually-hidden'>Processing image capture</span>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
)

CameraView.displayName = 'CameraView'
